// Kulkutavat käyttöliittymää varten. Sama lista kuin palvelimella
// (backend/app/modes.py); kopio on tässä, jotta retken voi aloittaa ilman
// verkkoyhteyttä. Palvelin tarkistaa arvot joka tapauksessa.

export const MODES = [
  { id: "walk", label: "Kävely", eligible: true },
  { id: "run", label: "Juoksu", eligible: true },
  { id: "bike", label: "Pyöräily", eligible: true },
  { id: "ebike", label: "Sähköavusteinen pyöräily", eligible: true },
  { id: "ski", label: "Hiihto", eligible: true },
  { id: "snowshoe", label: "Lumikenkäily", eligible: true },
  { id: "skate", label: "Luistelu", eligible: true },
  { id: "paddle", label: "Melonta tai soutu", eligible: true },
  { id: "kickscooter", label: "Potkulauta", eligible: true },
  { id: "wheelchair", label: "Pyörätuoli", eligible: true },
  { id: "car", label: "Auto", eligible: false },
  { id: "motorbike", label: "Moottoripyörä tai mopo", eligible: false },
  { id: "snowmobile", label: "Moottorikelkka", eligible: false },
  { id: "motorboat", label: "Moottorivene", eligible: false },
  { id: "escooter", label: "Sähköpotkulauta", eligible: false },
  { id: "public_transport", label: "Julkinen liikenne", eligible: false },
];

export const modeById = Object.fromEntries(MODES.map((m) => [m.id, m]));
export const modeLabel = (id) => modeById[id]?.label ?? id;
export const isEligible = (id) => Boolean(modeById[id]?.eligible);
